import { Component, ContentChild, Input } from '@angular/core';
import { FormControlName } from '@angular/forms';

@Component({
  selector: 'gcc-character-counter',
  templateUrl: './character-limit.component.html',
  styleUrls: ['./character-limit.component.scss'],
  standalone: false
})
export class CharacterLimitComponent {
  @ContentChild(FormControlName) public control: FormControlName;
  @Input() public withLimit: number;

  get value(): string {
    return (this.control && this.control.value) || '';
  }
}
